/**
 * sql/770 („Alte Fassung kurz sperren“): wer „À la carte“ nach dem Versand umschaltet, hat damit NICHTS falsch gemacht.
 * Der Server sperrt die versendete Fassung, bis neu gesendet wird, und meldet jeden Annahmeweg mit
 * 409 `fassung_wird_aktualisiert` und dem Text „Geändert – bitte neu senden. Bis dahin kann der Gast nicht annehmen.“
 *
 * Mimmo (Betreiber Storia, 04.11.2026): oben auf der Vorgangsseite stand dazu ein roter Kasten „Etwas ist schiefgelaufen“.
 * Das ist ein Hinweis mit nächstem Schritt, kein Fehler. Diese Datei hat den EINEN Hinweis (ruhige Karte, Knopf
 * „Jetzt neu senden“) und `FehlerOderHinweis`, die überall dort statt des rohen `ErrorNote` steht, wo ein Fehlertext
 * aus einer Aktion angezeigt wird (Vorgang, Builder).
 */
import { Button, ButtonRouterLink, ErrorNote, Icon } from "./components";
import { FASSUNG_NEU_SENDEN_TITEL, FASSUNG_NEU_SENDEN_ZEILE, istFassungNeuSendenMeldung } from "../lib/a-la-carte";

export const JETZT_NEU_SENDEN = "Jetzt neu senden";

export function FassungNeuSendenHinweis({
  zumSenden,
  onNeuSenden,
  testId = "fassung-neu-senden-hinweis",
}: {
  /** Ziel, wenn der Knopf zum Senden-Dialog in einer anderen Seite führt (Vorgang -> Builder, öffnet ihn dort). */
  zumSenden?: string;
  /** Wenn der Senden-Dialog auf derselben Seite liegt (Builder). */
  onNeuSenden?: () => void;
  testId?: string;
}) {
  return (
    <div
      role="status"
      data-testid={testId}
      className="flex flex-wrap items-center gap-x-4 gap-y-3 rounded-xl border border-[#E7C98A] bg-[#FBF3E2] px-4 py-3 text-[#6B4E12] dark:border-white/10 dark:bg-white/[0.06] dark:text-[#E9D3A4]"
    >
      <Icon name="edit_document" className="shrink-0 text-[20px]" />
      <div className="min-w-0 flex-1">
        <p className="text-[13.5px] font-bold">{FASSUNG_NEU_SENDEN_TITEL}</p>
        <p className="mt-0.5 text-[12.5px]">{FASSUNG_NEU_SENDEN_ZEILE}</p>
      </div>
      {zumSenden ? (
        <ButtonRouterLink to={zumSenden} variant="primary" className="!px-4 !py-2 !text-[13px]" data-testid={`${testId}-knopf`}>
          <Icon name="send" className="text-[16px]" /> {JETZT_NEU_SENDEN}
        </ButtonRouterLink>
      ) : onNeuSenden ? (
        <Button type="button" variant="primary" className="!px-4 !py-2 !text-[13px]" onClick={onNeuSenden} data-testid={`${testId}-knopf`}>
          <Icon name="send" className="text-[16px]" /> {JETZT_NEU_SENDEN}
        </Button>
      ) : null}
    </div>
  );
}

/** Eine Aktion meldete `message`: ist es die Fassungs-Sperre, ein ruhiger Hinweis; sonst wie bisher der Fehlerkasten. */
export function FehlerOderHinweis({ message, zumSenden, onNeuSenden }: { message: string; zumSenden?: string; onNeuSenden?: () => void }) {
  if (istFassungNeuSendenMeldung(message)) return <FassungNeuSendenHinweis zumSenden={zumSenden} onNeuSenden={onNeuSenden} />;
  return <ErrorNote message={message} />;
}
